import { useCreatedEvent, useDeletedEvent, useGameContext } from "../../../core/game/client/useGameContext";
import { ReplicatedObjectEvent } from "../../../core/game/common/ReplicatedObjectView";
import { ReplicatedObject } from "../../../core/game/interfaces/ReplicatedObject";
import { WriteableReplicatedObject } from "../../../core/game/server/WriterContext";
import { getPlayerPrefix } from "../../../core/util/PlayerUtils";
export const BASE_CONTACT_TIME = 2.5;
const CONTACT_TIME_ADJUSTMENT_STEP = 0.25;
const MAX_TIME_ADJUSTMENT_STEPS = 2;
const MAX_GUESSES_PER_CATEGORY = 3;
export const GameStateViewFn = (oldData, newData) => {
    var _a, _b, _c, _d;
    const isSecretWordAssigned = newData.secretWord !== undefined;
    const wasSecretWordPreviouslyAssigned = oldData !== null && oldData.secretWord !== undefined;
    const hasSecretWordContentChanged = wasSecretWordPreviouslyAssigned !== isSecretWordAssigned || (oldData !== null && oldData.numRevealedLetters !== newData.numRevealedLetters);
    const hasClueDenyCompleted = oldData !== null && oldData.currentAdjustment > newData.currentAdjustment;
    return Object.assign(Object.assign({}, newData), { currentContactTime: BASE_CONTACT_TIME + newData.currentAdjustment * CONTACT_TIME_ADJUSTMENT_STEP, isOnPenultimateLetter: newData.numRevealedLetters === ((_b = (_a = newData.secretWord) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) - 1, currentSecretWordLetters: ((_c = newData.secretWord) !== null && _c !== void 0 ? _c : '').substring(0, (_d = newData.numRevealedLetters) !== null && _d !== void 0 ? _d : 0), 
        // secretWordChangedEvent: new ReplicatedObjectEvent(oldData === null || oldData.secretWord !== newData.secretWord || oldData.secretWordGiverId !== newData.secretWordGiverId),
        secretWordContentChangedEvent: new ReplicatedObjectEvent(hasSecretWordContentChanged), clueDenyCompletedEvent: new ReplicatedObjectEvent(hasClueDenyCompleted) });
};
export class WriteableGameState extends WriteableReplicatedObject {
    commitNewGuess(sourceId, sourceUsername, answer) {
        this.commitData({
            guesses: [{
                    playerId: sourceId,
                    playerPrefix: getPlayerPrefix(sourceUsername),
                    guess: answer,
                }, ...this.data.guesses]
        });
    }
    transformDataToCommit(dataInput) {
        let data = super.transformDataToCommit(dataInput);
        let numSecretWordGiverGuesses = 0;
        let numGuesserGuesses = 0;
        data.guesses = data.guesses.filter((guess) => {
            if (guess.playerId === data.secretWordGiverId) {
                numSecretWordGiverGuesses++;
                return numSecretWordGiverGuesses <= MAX_GUESSES_PER_CATEGORY;
            }
            else {
                numGuesserGuesses++;
                return numGuesserGuesses <= MAX_GUESSES_PER_CATEGORY;
            }
        });
        return data;
    }
    afterCommitData(oldData) {
        var _a;
        if (this.data.secretWordGiverId !== undefined && this.data.secretWord !== undefined && ((_a = this.data.numRevealedLetters) !== null && _a !== void 0 ? _a : 0) >= this.data.secretWord.length) {
            this.context.commitEndGame({
                gameEndReason: 'GameFinished',
                details: {
                    winner: 'Guessers',
                    secretWord: this.data.secretWord,
                }
            });
        }
    }
    commitNewSecretWordGiver() {
        const players = this.context.players.data.getPlayerIds();
        if (this.data.secretWordGiverId !== undefined) {
            players.splice(players.indexOf(this.data.secretWordGiverId), 1);
        }
        const newSecretWordGiverId = players[Math.floor(Math.random() * players.length)];
        this.commitData({
            secretWordGiverId: newSecretWordGiverId,
        });
    }
    addPreviousClue(clue) {
        if (this.data.previousClues.includes(clue))
            return;
        this.commitData({
            previousClues: [...this.data.previousClues, clue],
        });
    }
    getClampedIncrementedAdjustment(increment) {
        return Math.max(-MAX_TIME_ADJUSTMENT_STEPS, Math.min(MAX_TIME_ADJUSTMENT_STEPS, this.data.currentAdjustment + increment));
    }
    isClueSecretOutOfDate(clueSecret) {
        if (this.data.secretWord === undefined) {
            return true;
        }
        return !clueSecret.startsWith(this.data.secretWord.substring(0, this.data.numRevealedLetters));
    }
}
export const GameState = new ReplicatedObject('GameState', [{ required: 'gameState' }], WriteableGameState, (input, data) => 'gameState', GameStateViewFn);
export function useGameState() {
    return useGameContext('gameState');
}
export function useGameStateCreatedEvent() {
    return useCreatedEvent('gameState');
}
export function useGameStateDeletedEvent() {
    return useDeletedEvent('gameState');
}
//# sourceMappingURL=GameState.js.map